import {Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';

import {NetworkHelperService} from '../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../_config/strings';
import * as moment from 'moment';
import * as alertfy from 'alertifyjs';

import Swal from 'sweetalert2';
import {Usuario} from '../../_model/Usuario';
import {Subject} from 'rxjs/Subject';
import { count } from 'rxjs/operators';
// import { setInterval } from 'timers';
import { Route, Router } from '@angular/router';
import { ChatService } from '../../_services/chat.service';
import { element } from 'protractor';
import { empty } from 'rxjs/observable/empty';
import * as html2canvas from "html2canvas"

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit, OnDestroy {
@Output() esLaUrl = new EventEmitter();

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  CODFUNC: any;
  PAGE: any;
  GENERALES: any;
  $: any;

  public usuario: Usuario = new Usuario();
  notificacionesArray = [];
  copia = [];
  noti = [];
  estado = true;

  alertNotificacion = false;
  noti2 = [];

  elemento;

  bandera = false;
  audio;

  notificaciones = [];
  elementosMenu;
  mensajeChatModal;

  mensajeChat;
  mensajeGlobalText;

  sala;
  salaAll;

  chatTarget;

  usuariosAll = [];
  notificacionesSonido;
  notificacionesChat;

  chatBox = [];

  variable;

  interval;
  banderaNoti = 0;

  hayNotificacion = false;

  busquedaChatText = '';
  usuariosFiltrados = [];
  existeChat = false;

  nombreChat;

  objetoDeSalas = [];

  hayMensaje = false;
  cuantosMensajes = 0;
  escribiendoChat;
  escribeChat;

  htmlCap:any;

  // tiempo variables

  constructor(
    private network: NetworkHelperService,
    private rutas: Router,
    private chat: ChatService
  ) {
    this.htmlCap = html2canvas;
    this.FORMS = FORMS;
    this.API = API;
    this.CODFUNC = CODFUNC;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    // this.rutas.routeReuseStrategy.shouldReuseRoute = function() {return true; };
    this.interval = setInterval(() => {
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    if (!this.usuario) {
      // console.log('perfil false');
      this.getUser();
  } else {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }}, 300);
    this.notificacionesSonido = new Audio();
    this.notificacionesSonido.src = '../../../assets/sounds/messenger-tono-mensaje-.mp3';
    this.notificacionesSonido.load();
    this.notificacionesChat = new Audio();
    this.notificacionesChat.src = '../../../assets/sounds/ringtones-heart.mp3';
    this.notificacionesChat.load();
  }

  ngOnInit() {
    
    // let mensajeRecibido;
    this.getNotificaciones();
    var navegador = this.rutas;
    var emisor = this.esLaUrl;
    let network = this.network;
    let banderaQueSiHayNoti;
    let baderanotificacion;
    setTimeout(() => {
     // this.test();
     // console.log('TopBar se esta suscribiendo sin settime');
    this.chat.messages.subscribe(msg => {
       // console.log(msg);
      if (msg.type === 'chat') {
        this.escribeChat = '';
        this.chat.sendMsg('');
        this.hayMensaje = true;
        //alertfy.success(msg.autour + ' dice: ' + msg.text, 10);
        this.notificacionesChat.play();
        let user = this.usuariosFiltrados.find(e => e.username == msg.autour);
        let userAll = this.usuariosAll.find(e => e.username == msg.autour);
        user.nMensajes = user.nMensajes + 1;
        userAll.nMensajes = userAll.nMensajes + 1;
        this.cuantosMensajes = this.cuantosMensajes +  1;
        this.usuariosFiltrados.sort(function (a, b) {
          if (a.nMensajes > b.nMensajes) {
            return -1;
          }
          if (a.nMensajes < b.nMensajes) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });
       
        if (msg.target !== msg.autour) {
         
        this.chatBox.push({
          emisor: msg.autour,
          mensaje: msg.text,
          receptor: this.usuario.userName,
          imagen: user.imagen,
          fecha: moment().format().split('T')[0],
          hora: moment().format().split('T')[1].split('-')[0],
          visto: false
        });
        this.objetivoChat(msg.autour);
      }
      }
      else if (msg.type === 'notificacion') {
        this.getNotificaciones();
        this.hayNotificacion = true;
        var chat = alertfy.error(msg.text, 7600);
        let mensajeId = msg.id;
        chat.callback = function (isClicked) {
          if(isClicked)
          {
            Swal({
              title: 'Atencion',
              text: 'Ir al evento?',
              type: 'info',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Si, deseo ir!'
            }).then((result) => {
              if (result.value) {
                baderanotificacion = $('#prodId').val();
                baderanotificacion = baderanotificacion -1;
  if (baderanotificacion > 0) {
    //console.log('entro en mayor a cero');
    document.getElementById('tituloPagina').innerText = 'Tienes ('+baderanotificacion+') notificaciones';
    $('nNotisX').val('('+baderanotificacion+')');
  } else if (baderanotificacion === 0) {
    //console.log('entro en igual a cero');
    document.getElementById('tituloPagina').innerText = 'SM8 Versión Alfa: 0.1.2.3';
  }
  else {
   // console.log('entro en menor a cero');
    baderanotificacion = 0;
  }
  baderanotificacion = $('#prodId').val(baderanotificacion);
                network.callSecureService(
                  'dashboard/notificaciones/' + mensajeId,
                  'GET',
                  null)
                  .subscribe((response: any) => {
                    // console.log('cambio ok');
                }, err => {
                  console.log(err);
                  Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                });
                navegador.navigate(['protected']);
                emisor.emit({urlPay: msg.url});
              }
          });
          }
        }
        // this.test();
        this.notificacionesSonido.play();
      } else if (msg.type === 'mensajeGlobal'){
        let canDismiss = false;
        alertfy.set('notifier','position', 'bottom-center');
        var notification = alertfy.warning(msg.autour + ' dice: ' + msg.text);
        notification.ondismiss = function(){ return canDismiss; };
        setTimeout(function(){ canDismiss = true;}, 1800000);
       // alertfy.set('notifier','position', 'bottom-center');
        //alertfy.notify(msg.autour + ' dice: ' + msg.text, 3600);
      } else if (msg.type === 'getRooms')
      {
        this.objetoDeSalas = Object.keys(msg.text);
        this.actualizarOnline(Object.keys(msg.text));
      } else if( msg.type === 'visto' )
      {
        this.chatTarget = [];
        let visualizados = this.chatBox.filter(e => e.receptor == this.sala.username && e.visto == false);
      //  console.log(visualizados);
        for(let visto of visualizados)
        {
          visto.visto = true;
        }
        this.objetivoChat(msg.autour);
      }
       else if (msg.type === 'escribiendo')
       {
         if(msg.autour == this.sala.username)
         {
         this.escribeChat = 'escribiendo...'
         }
       }
      });
      //console.log(this.banderaNoti);
      this.getUsuarios();
    }, 5000);
  }

  getNotifica() {
    this.hayNotificacion = false;
    this.estado = true;
    this.getNotificaciones();
    this.estado = false;
    this.alertNotificacion = false;

    // console.log(this.notificacionesArray);
  }

  capturaP()
  {
    let pito = $('#main-wrapper');
    console.log(pito[0]);
    let pay = document.getElementById("main-wrapper");
    console.log(pay);
        this.htmlCap(pay, {useCORS: true, width: 400, height: 300}).then(function(canvas) {
          setTimeout(()=>{var image = canvas.toDataURL("image/jpg");  
            console.log(image);
          var downloadLink = document.createElement('a');
          
              // Create a link to the file
              downloadLink.href = image;
              // Setting the file name
              downloadLink.download = "screenshot.jpg";
              // triggering the function
              downloadLink.click();}, 500);
      
  });
  
    
  }

  getRooms()
  {
    this.chat.sendMsg(''); 
   // console.log('entro en rooms');
  }

  actualizarOnline(objetoDeSalas){
    this.usuariosAll.forEach(element => {
      const actualizar = objetoDeSalas.find(e => e == element.username);
      if(actualizar)
      {
      element.enLinea = true;
      } 
    });
    this.usuariosFiltrados.forEach(element => {
      const actualizar = objetoDeSalas.find(e => e == element.username);
      if(actualizar)
      {
      element.enLinea = true;
      } 
    });

  }


  setEstatus(id) {
    this.network.callSecureService(
      this.API.user.notificaciones + '/' + id,
      'GET',
      null)
      .subscribe((response: any) => {
        // console.log('cambio ok');
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }


  ir(url) {
    this.rutas.navigate(['dashboard', url]);
  }

  getNotificaciones() {
    this.banderaNoti = 0;
    this.network.callSecureService(
        this.API.user.notificaciones + '/recientes',
        'GET',
        null)
        .subscribe((response: any) => {
              this.notificacionesArray = [];
              for (const notificaciones of response.Mensaje) {
                if (notificaciones.estatus.estatus === 'NOLEIDO') {
                  this.banderaNoti = this.banderaNoti + 1;
                }
              // separemos la fecha para mostrarl mejor y hace calculos
                const arrayFecha = notificaciones.fecha.split('+');
                const fecha = arrayFecha[0];
                // console.log(moment().format('HH:mm:ss'));
                const date = moment(fecha).fromNow(true);
                this.notificacionesArray.push({
                  id: notificaciones.id,
                  mensaje: notificaciones.mensaje,
                  sucursalNombre: notificaciones.sucNombre,
                  url: notificaciones.url,
                  tiempo: date,
                  user: notificaciones.usuarioNombre,
                  iconVisto: notificaciones.estatus.estatus
                 // estatus: notificaciones.estatus
                });

              }
              // console.log(this.banderaNoti);
              if (this.banderaNoti > 0) {
                this.hayNotificacion = true;
                document.getElementById('tituloPagina').innerText = 'Tienes ('+this.banderaNoti+') notificaciones';
                $('nNotisX').val('('+this.banderaNoti+')');
              } else if (this.banderaNoti === 0) {
                document.getElementById('tituloPagina').innerText = 'SM8 Versión Alfa: 0.1.2.3';
              } else {
                this.banderaNoti = 0;
              }
              $('#prodId').val(this.banderaNoti);
              this.notificacionesArray.reverse();
              this.noti = this.notificacionesArray;

              this.dtTrigger.next();

            }, err => {
              console.log(err);
              if (err.error.code === 401) {
                  console.log('entro en id de codigo');
                  location.href = '/login';
              }
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );

  }

  getUser() {

    if (localStorage.getItem('usuario')) {
        this.usuario = JSON.parse( localStorage.getItem('usuario') );
    }
}

  getUsuarios() {
    this.chat.sendMsg('');
    this.usuariosFiltrados = [];
    this.usuariosAll = [];
    this.network.callSecureService(
      'usuarios' + '/all',
      'GET',
      null)
      .subscribe((response: any) => {
      // console.log(response);
      for (const user of response.Mensaje) {
        const room = this.objetoDeSalas.find(e => e == user.username);
        if(room)
        {
      this.usuariosAll.push({
        id: user.id,
        nombre: user.nombre,
        username: user.username,
        puesto: user.puesto,
        sucursal: user.sucursal,
        imagen: this.API.imagenesPerfil + user.imagen,
        enLinea: true,
        nMensajes: 0
      });
      this.usuariosFiltrados.push({
        id: user.id,
        nombre: user.nombre,
        username: user.username,
        puesto: user.puesto,
        sucursal: user.sucursal,
        imagen: this.API.imagenesPerfil + user.imagen,
        enLinea: true,
        nMensajes: 0
      });
      } else {
        this.usuariosAll.push({
          id: user.id,
          nombre: user.nombre,
          username: user.username,
          puesto: user.puesto,
          sucursal: user.sucursal,
          imagen: this.API.imagenesPerfil + user.imagen,
          enLinea: false,
          nMensajes: 0
        });
        this.usuariosFiltrados.push({
          id: user.id,
          nombre: user.nombre,
          username: user.username,
          puesto: user.puesto,
          sucursal: user.sucursal,
          imagen: this.API.imagenesPerfil + user.imagen,
          enLinea: false,
          nMensajes: 0
        });
      }
    }
    }, err => {
      console.log(err);
      if (err.error.code === 401) {
          console.log('entro en id de codigo');
          location.href = '/login';
      }
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

objetivoChat(usuario) {
 
 if(this.sala)
 {
   if(this.sala.username == usuario)
   {
  this.sala = this.usuariosAll.find(e => e.username == usuario);
  // this.chat.conecRoom(this.usuario.userName);
  this.chatTarget = this.chatBox.filter(elemento => elemento.receptor === usuario || elemento.emisor === usuario);
  // console.log(this.chatTarget);
  $('.chatbox__body').scrollTop( $('.chatbox__body').prop('scrollHeight') );
   }
 } else {
  this.sala = this.usuariosAll.find(e => e.username == usuario);
  // this.chat.conecRoom(this.usuario.userName);
  this.chatTarget = this.chatBox.filter(elemento => elemento.receptor === usuario || elemento.emisor === usuario);
  // console.log(this.chatTarget);
  $('.chatbox__body').scrollTop( $('.chatbox__body').prop('scrollHeight') );
 }
  
}

objetivoChatInicializar(usuario) {
  //this.activarFuncionesChat();
  
    this.existeChat = true;

  this.sala = this.usuariosFiltrados.find(e => e.username == usuario);
  this.salaAll = this.usuariosAll.find(e => e.username == usuario);
  //this.cuantosMensajes = this.cuantosMensajes - this.sala.nMensajes; 
 // this.sala.nMensajes = 0;
  // this.chat.conecRoom(this.usuario.userName);

  this.network.callSecureService(this.API.user.mensajes.obtener, 'POST', {targetId: this.sala.id}).subscribe((response:any) => {
    //console.log(response);

      this.chatTarget = this.chatBox.filter(elemento => elemento.receptor === usuario || elemento.emisor === usuario);
  //console.log(this.chatTarget);
      if(this.chatTarget.length == 0)
      {
        //console.log('pay');
        for (let mensaje of response.Mensaje)
        {
      this.chatBox.push({
          emisor: mensaje.usuario,
          mensaje: mensaje.mensaje,
          receptor: mensaje.target,
          imagen: this.API.imagenesPerfil + mensaje.usuarioPic,
          fecha: mensaje.fecha.split('T')[0],
          hora: mensaje.fecha.split('T')[1].split('-')[0],
          visto: mensaje.visto
          });
      }
    }
    this.chatTarget = this.chatBox.filter(elemento => elemento.receptor === usuario || elemento.emisor === usuario);
  }, err =>{console.log(err)});

  // console.log(this.chatTarget);
  setTimeout(()=>{
    this.activarFuncionesChat();
  }, 500);
  
}

visto()
{
 // console.log('entro en visto');
  this.cuantosMensajes = this.cuantosMensajes - this.sala.nMensajes; 
  this.sala.nMensajes = 0;
  this.salaAll.nMensajes = 0;

  this.network.callSecureService(this.API.user.mensajes.visto, 'POST', {targetId: this.sala.id}).subscribe((response:any) => {
    //console.log(response);
  }, err =>{console.log(err)});
  let mensaje = {
    mensaje: 'true',
    usuario: this.usuario.userName,
    target: this.sala.username,
    tipo: 'visto'
  };
  
    this.chat.sendMsg(mensaje);

}

activarFuncionesChat()
{
  (function($) {
    $(document).ready(function() {
        var $chatbox = $('.chatbox'),
            $chatboxTitle = $('.chatbox__title'),
            $chatboxTitle2 = $('.chatbox__title2'),
            $chatboxTitleClose = $('.chatbox__title__close'),
            $chatboxCredentials = $('.chatbox__credentials');
        $chatboxTitle.on('click', function() {
            $chatbox.toggleClass('chatbox--tray');
        });
        $chatboxTitle2.on('click', function() {
          $chatbox.toggleClass('chatbox--tray');
      });
        $chatboxTitleClose.on('click', function(e) {
            //e.stopPropagation();
            //$chatbox.addClass('chatbox--closed');
        });
        $chatbox.on('transitionend', function() {
            if ($chatbox.hasClass('chatbox--closed')) $chatbox.remove();
        });
        
    });
})(jQuery);
  
}

closeChat()
{
  this.existeChat = false;
}


  chatModal() {
    const username = this.sala.username;
    // console.log('submited');
    let text = $('#textChat');
    // console.log(text.val());
    let sendChat = [{
      mensaje: text.val(),
      target: username
    }];
    // console.log(sendChat);
    this.sendMessage(sendChat);
    text.val('');
    // this.sala = [];
  }

  sendMessage(sendChat) {
  // console.log(sendChat[0].mensaje);
  // console.log(sendChat[0].target);
  let mensaje = {
    mensaje: sendChat[0].mensaje,
    usuario: this.usuario.userName,
    target: sendChat[0].target,
    tipo: 'chat'
  };
    this.chat.sendMsg(mensaje);
    let userPic = this.usuariosAll.find(e => e.username === this.usuario.userName)
    this.chatBox.push({
      emisor: this.usuario.userName,
      mensaje: sendChat[0].mensaje,
      receptor: sendChat[0].target,
      imagen: userPic.imagen,
      fecha: moment().format().split('T')[0],
      hora: moment().format().split('T')[1].split('-')[0],
      visto: false
    });

    //aqui enviamos a la base de datos

    this.network.callSecureService(this.API.user.mensajes.enviar, 'POST', {mensaje: sendChat[0].mensaje, targetId: this.sala.id}).subscribe((response:any) => {
     // console.log(response);
    }, err =>{console.log(err)});
    
    
    this.objetivoChat(mensaje.target);
  }

  goToUrl(url) {
    // console.log(url);
    this.esLaUrl.emit({urlPay: url});
  }

  goToUrl2(url) {
    // console.log(url);
    this.banderaNoti = this.banderaNoti - 1;
    //console.log(this.banderaNoti);
    if (this.banderaNoti > 0) {
      this.hayNotificacion = true;
      document.getElementById('tituloPagina').innerText = 'Tienes ('+this.banderaNoti+') notificaciones';
      $('nNotisX').val('('+this.banderaNoti+')');
    } else if (this.banderaNoti === 0) {
      document.getElementById('tituloPagina').innerText = 'SM8 Versión Alfa: 0.1.2.3';
    } else {
      this.banderaNoti = 0;
    }
    $('#prodId').val(this.banderaNoti);
    this.esLaUrl.emit({urlPay: url});
  }

ngOnDestroy() {}

  logOut() {
    this.ngOnDestroy();
    this.network.logOut();
  }

  mensajeGlobal()
  {
    this.mensajeGlobalText = $('#textMensajeGlobal').val();
    this.usuariosAll.forEach(e => {
     
      let mensaje = {
        mensaje: this.mensajeGlobalText,
        usuario: this.usuario.userName,
        target: e.username,
        tipo: 'mensajeGlobal'
      };
        this.chat.sendMsg(mensaje);
    });
    
  }

  busquedaChat()
  { 
    this.chat.sendMsg(''); 
    let longitudCadena = this.busquedaChatText.length;
    let comparacion = this.busquedaChatText.split(this.busquedaChatText[longitudCadena])[0];
    this.usuariosFiltrados = this.usuariosAll.filter(filtro => filtro.nombre.split(filtro.nombre[longitudCadena])[0].toLowerCase() == comparacion.toLowerCase());
    
  }
  closeWindowsChat()
  {

  }

  escribiendo() {
    let mensaje = {
      mensaje: 'escribiendo...',
      usuario: this.usuario.userName,
      target: this.sala.username,
      tipo: 'escribiendo'
    };
    
      this.chat.sendMsg(mensaje);
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_shared/top-bar/top-bar.component.ts